<template>

    <div v-if="formData.sent" class="success">
        <h2>{{data.value?.local?.sent}}</h2>
        <p>{{data.value?.local?.thanks}}</p>
        <img class="successImg" :src="data.value?.successImage" :alt="data.value?.local?.thanks">

        <div class="controls">
            <button class="close mainButton" @click="closeModal">{{data.value?.local?.close}}</button>
        </div>

    </div>

    <form v-else class="comment_form">
        <h2>{{data.value?.local?.target}} {{data.value?.title}}</h2>
        <div class="divider"></div>
        <label class="rating_holder">{{data.value?.local?.rating}}</label>
        <div class="rating">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                v-for="n in 5"
                :key="n"
                @mouseover="handleMouseOver(n)"
                @mouseout="handleMouseOut"
                @click="handleClick(n)"
            >
                <g clip-path="url(#clip0_1082_6102)">
                    <path
                        d="M8.54077 1.06637C8.71432 0.663389 9.28569 0.66339 9.45923 1.06637L11.316 5.37799C11.3884 5.54608 11.5468 5.66119 11.7291 5.67809L16.4034 6.11162C16.8403 6.15214 17.0169 6.69555 16.6872 6.98513L13.1604 10.0834C13.0229 10.2042 12.9624 10.3904 13.0027 10.569L14.0348 15.1485C14.1313 15.5765 13.669 15.9124 13.2917 15.6884L9.25528 13.2916C9.09792 13.1981 8.90208 13.1981 8.74472 13.2916L4.70825 15.6884C4.33099 15.9124 3.86874 15.5765 3.96521 15.1485L4.99735 10.569C5.03759 10.3904 4.97707 10.2042 4.83958 10.0834L1.31276 6.98512C0.98313 6.69555 1.15969 6.15214 1.59658 6.11162L6.27095 5.67809C6.45318 5.66119 6.61161 5.54608 6.684 5.37799L8.54077 1.06637Z"
                        :fill="(n <= currentRating ? '#F67B09' : '#E0E0E0')"
                    />
                </g>
                <defs>
                    <clipPath>
                        <rect width="18" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>

        <div class="inputHolder">
            <label for="name">{{data.value?.local?.yourName}}</label>
            <input type="text" name="name" id="name" v-model="formData.name">
        </div>

        <div class="inputHolder">
            <label for="comment">
                <span>{{data.value?.local?.comment}}</span>
                <span class="input-counter">{{ formData.comment?.length || 0 }} / 1000</span>
            </label>
            <textarea name="comment" id="comment" v-model="formData.comment" @keydown="handleKeyDown"></textarea>
        </div>
        <div class="controls">
            <button type="submit" @click.prevent="addReview" :disabled="!formData.name || !formData.comment" class="mainButton" :class="{loading: loading}"><span>{{data.value?.local?.submit}}</span></button>
        </div>

    </form>
</template>

<script setup>

import {onMounted, reactive, ref} from "vue";
import {ajax, getCookie} from "@/assets/js/Functions"
import '@/assets/css/form.css'
import '@/assets/css/reviews.css'
import bus from '@/store/EventBus.js';


const emit = defineEmits(['close'])
const props = defineProps({
    trigger: Object,
    params: Object,
});

const data = reactive({})
const currentRating = ref(0)
const formData = reactive({
    name: null,
    comment_rating: null,
    comment: null,
    sent: false
})
const loading = ref(false)

const handleKeyDown = (event) => {
    if (formData.comment && formData.comment.length >= 1000 && event.key.length === 1) {
        // Остановить ввод, если достигнут лимит символов
        event.preventDefault();
    }
};

function handleMouseOver(n) {
    currentRating.value = n;
}
function handleMouseOut() {
    currentRating.value = formData.comment_rating;
}
function handleClick(n) {
    formData.comment_rating = n;
}

const addReview = () => {
    loading.value = true
    ajax({
        action: 'insert_comment',
        comment_rating: formData.comment_rating,
        comment_author: formData.name,
        comment_content: formData.comment,
    }, (response) => {
        formData.sent = true
        loading.value = false

        // Убираем кнопку добавления отзыва после успешного добавления отзыва
        const addButton = document.querySelector('.reviews_feedback .feedback')
        if (addButton) addButton.parentNode.removeChild(addButton)
    });
}

onMounted(async () => {
    ajax({
        action: "get_comment_form",
    }, (response) => {
        data.value = response
    })
})

const closeModal = () => {
    emit('close');
}

</script>

<style scoped>

form, .formHolder {
    padding: 0;
    width: 100%;
    margin: 0;
    box-shadow: none;
}
.controls .mainButton{
    margin-bottom: 0;
}
.rating{
    display: flex;
    margin-bottom: 20px;
}
.rating svg{
    width: 54px;
    height: 30px;
    cursor: pointer;
    padding-right: 24px;
}
.rating svg:last-child{
    padding-right: 0;
    width: 30px;
}
h2{
    font-size: 22px;
    font-weight: 600;
    line-height: 130%;
    margin: 0 0 26px;
}
.divider{
    background: #E0E0E0;
    height: 1px;
    width: 100%;
    margin: 0 0 26px;
}
.title{
    color: #333;
    font-size: 14px;
    font-weight: 500;
    line-height: 130%;
    margin-bottom: 10px;
    text-align: left;
}
label{
    margin-bottom: 26px;
    width: 100%;
    display: block;
    text-align: left;
    height: auto;
}
label > span{
     font-size: 14px;
     font-weight: 500;
     margin-bottom: 16px;
     display: flex;
     align-items: center;
     justify-content: space-between;
     line-height: 130%;
 }

button.loading {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

button.loading .loading_spinner {
    margin-left: 10px;
    width: 20px;
    height: 20px;
    border: 2px solid transparent;
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}
button.loading.black .loading_spinner {
    border-top-color: #333;
}

div.success{
    text-align: center;
    width: 100%;
}

div.success p{
    font-size: 18px;
    font-weight: 400;
    line-height: 130%;
    margin-bottom: 80px;
}
div.success img{
    margin-bottom: 80px;
}
.successImg{
    width: 150px;
    height: 150px;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@media all and (max-width: 768px){
    form{
        overflow-y: auto;
    }
    h2 {
        font-size: 18px;
        margin: 0 0 20px;
        text-align: left;
    }
    .divider {
        margin: 0 0 20px;
    }
    div.success h2 {
        font-size: 22px;
        margin: 30px 0 10px;
        text-align: center;
    }
    div.success p {
        font-size: 16px;
    }
}

</style>